class TabMenu{
    constructor(opts){
        this.opts = $.extend(true, {
            el:"#selected"
        }, opts);

        this.$el = $(this.opts.el);
        this.$list = this.$el.find("[data-selected]");

        this.currId = "";
        this.prevId = "";
        this.setComplete = "";

        this.init();
    };

    init(){
        this.controls();
    };

    controls(){
        this.$el.on("click", "[data-selected]", (evt)=>{
            this.currId = $(evt.currentTarget).data("selected");
            if(this.currId===this.prevId) return;
            this.addSelect(this.currId);
        });
    }

    removeSelect(){
        this.$el.find("[data-selected]").removeClass("item-table__tr--on");
        this.$el.find("[data-selected]").find("[data-radio]").prop('checked', false);
    }

    addSelect(name){
        if(this.prevId!=="") {
            this.$el.find("[data-selected="+this.prevId+"]").removeClass("item-table__tr--on");
            this.$el.find("[data-selected="+this.prevId+"]").find("[data-radio]").prop('checked', false);
        }
        this.$el.find("[data-selected="+name+"]").addClass("item-table__tr--on");
        this.$el.find("[data-selected="+name+"]").find("[data-radio]").prop('checked', true);
        this.prevId = name;
    }

    set seletedSet(str){
        if(str==="reset"){
            this.removeSelect();
            this.currId = "";
            this.prevId = "";
        }
    }

};

export default TabMenu;


// WEBPACK FOOTER //
// ./src/js/util/selected.js